import React from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { Shape, ExtrudeBufferGeometry, MeshStandardMaterial } from 'three';
import * as THREE from 'three';
import {subsystems, wallColor, wallOpacity,
} from 'utils/constant';

export default function CapellaBottom(props) {
    const { viewport } = useThree();
    const width = props.width * 0.001;
    const depth = props.depth * 0.001;
    const int_width = subsystems[9].width;
    const int_depth = subsystems[9].height;
    const dw = (width - props.width) * 0.001;
    const dd = (depth - props.depth) * 0.001;
    const alpha = Math.PI / 12 + 0.013;
    const height = (2840 + props.depth / 2 * Math.tan(alpha)) * 0.001;

    const points = [
      [0, 0],
      [0, height - depth * Math.tan(alpha)],
      [-depth, height],
      [-depth, 0],
      [0, 0]
    ];
  
    const ladderShape = new Shape();
    ladderShape.moveTo(points[0][0], points[0][1]);
    for (let i = 1; i < points.length; i++) {
      ladderShape.lineTo(points[i][0], points[i][1]);
    }
  
    const ladderExtrudeSettings = {
      steps: 2,
      depth: 0.15,
      bevelEnabled: false
    };
  
    const ladderGeometry = new ExtrudeBufferGeometry(
      ladderShape,
      ladderExtrudeSettings
    );
  
    const ladderMaterial = new MeshStandardMaterial({ color: wallColor, opacity: 0.9, transparent: true });
    
    return (
      <group>
          <mesh geometry={ladderGeometry} material={ladderMaterial} position={[-dd / 2 - 0.2, -0.8, -1.54]} />
          <mesh geometry={ladderGeometry} material={ladderMaterial} position={[-dd / 2 - 0.2, -0.8, -1.62 + width]} />
      </group>
    );
}